// Author Liang Gang Qiang
// Date 2022-02-28 09:07:43

import * as model from "@/model/sithMes/prd/SithMesPrdPpdScheduledResultItemPsriModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpdScheduledResultItemPsri(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
